import * as React from "react";
import DxButton from "devextreme-react/button";
import DxSelectBox from "devextreme-react/select-box";
import DxTextArea from "devextreme-react/text-area";
import DxTextBox from "devextreme-react/text-box";
import { DeliveryStatus, Message } from "../api/SendService";
import { sendService } from "api/SendService";

export function TestMessage() {
    const [transports] = React.useState<string[]>(["Email", "Telegram", "Sms"]);
    const [resultDetail, setResultDetail] = React.useState<string>();
    const [deliveryStatus, setDeliveryStatus] = React.useState<DeliveryStatus>();

    const recipientRef = React.useRef<DxTextBox>(null);
    const transportRef = React.useRef<DxSelectBox>(null);
    const subjectRef = React.useRef<DxTextBox>(null);
    const bodyRef = React.useRef<DxTextArea>(null);

    const handleSend = () => {
        var msg: Message = {
            subject: subjectRef.current?.instance.option("value") ?? "",
            recipients: [
                {
                    contact: recipientRef.current?.instance.option("value") ?? "",
                    transport: transportRef.current?.instance.option("value"),
                },
            ],
            body: bodyRef.current?.instance.option("value") ?? "",
        };

        setDeliveryStatus(DeliveryStatus.Unknown);
        setResultDetail("Sending...");
        sendService
            .TestMessage(msg)
            .then((data) => {
                setDeliveryStatus(data.deliveryResults[0]?.deliveryStatus);
                setResultDetail(data.deliveryResults[0].error);
            })
            .catch((data: any) => setResultDetail(JSON.stringify(data.responseJSON, null, 4)));
    };

    return (
        <div className="form-horizontal">
            <div className="form-group">
                <label className="control-label col-sm-3">{"Transport"}</label>
                <div className="col-sm-5">
                    <DxSelectBox dataSource={transports} ref={transportRef} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-3">{"Recipient"}</label>
                <div className="col-sm-5">
                    <DxTextBox ref={recipientRef} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-3">{"Subject"}</label>
                <div className="col-sm-5">
                    <DxTextBox ref={subjectRef} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-3">{"Body"}</label>
                <div className="col-sm-5">
                    <DxTextArea ref={bodyRef} />
                </div>
            </div>
            <div className="form-group">
                <div className="col-sm-5 col-sm-offset-3">
                    <DxButton text={"Send"} onClick={handleSend} />
                </div>
            </div>

            <div className="form-group">
                <label className="control-label col-sm-3">{"Send result"}</label>
                <div className="col-sm-5">
                    <div className="form-group">
                        <p style={{ paddingTop: "4px" }}>
                            <DeliveryStatusDisplay deliveryStatus={deliveryStatus} />
                        </p>
                        {/* <DxTextBox value={deliveryStatus?.toString()} /> */}
                    </div>

                    {resultDetail && (
                        <div className="form-group">
                            <DxTextArea value={resultDetail} autoResizeEnabled={true} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function DeliveryStatusDisplay(props: { deliveryStatus?: DeliveryStatus }) {
    switch (props.deliveryStatus) {
        case DeliveryStatus.Error:
            return (
                <span>
                    <i className="fa fa-exclamation-circle text-danger" />
                    &nbsp; {"Error"}
                </span>
            );
        case DeliveryStatus.Delivered:
            return (
                <span>
                    <i className="fa fa-check-circle text-success" />
                    &nbsp; {"Delivered"}
                </span>
            );
        case DeliveryStatus.Queued:
            return (
                <span>
                    <i className="fa fa-clock-o text-warning" />
                    &nbsp; {"Queued"}
                </span>
            );
        default:
            return null;
    }
}
